import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _a312ba22 = () => interopDefault(import('../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _407ee18c = () => interopDefault(import('../pages/HealthCheck/Get.vue' /* webpackChunkName: "pages/HealthCheck/Get" */))
const _6ab084b9 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _08b9fe92 = () => interopDefault(import('../pages/_lang/index.vue' /* webpackChunkName: "pages/_lang/index" */))
const _51c75168 = () => interopDefault(import('../pages/_lang/404.html.vue' /* webpackChunkName: "pages/_lang/404.html" */))
const _a23b810a = () => interopDefault(import('../pages/_lang/login.html.vue' /* webpackChunkName: "pages/_lang/login.html" */))
const _5604a84e = () => interopDefault(import('../pages/_lang/return.html.vue' /* webpackChunkName: "pages/_lang/return.html" */))
const _7c2c5a70 = () => interopDefault(import('../pages/_lang/sureroute.html.vue' /* webpackChunkName: "pages/_lang/sureroute.html" */))
const _9f1a1650 = () => interopDefault(import('../pages/_lang/checkRobot/_id.vue' /* webpackChunkName: "pages/_lang/checkRobot/_id" */))
const _033d5bc2 = () => interopDefault(import('../pages/_lang/live/_id.vue' /* webpackChunkName: "pages/_lang/live/_id" */))
const _37f9133a = () => interopDefault(import('../pages/_lang/login.html' /* webpackChunkName: "" */))
const _69513b80 = () => interopDefault(import('../pages/_lang/checkRobot/_id' /* webpackChunkName: "" */))
const _9747c298 = () => interopDefault(import('../pages/_lang/404.html' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _a312ba22,
    name: "error"
  }, {
    path: "/HealthCheck/Get",
    component: _407ee18c,
    name: "HealthCheck-Get"
  }, {
    path: "/",
    component: _6ab084b9,
    name: "index"
  }, {
    path: "/:lang",
    component: _08b9fe92,
    name: "lang"
  }, {
    path: "/:lang/404.html",
    component: _51c75168,
    name: "lang-404.html"
  }, {
    path: "/:lang/login.html",
    component: _a23b810a,
    name: "lang-login.html"
  }, {
    path: "/:lang/return.html",
    component: _5604a84e,
    name: "lang-return.html"
  }, {
    path: "/:lang/sureroute.html",
    component: _7c2c5a70,
    name: "lang-sureroute.html"
  }, {
    path: "/:lang/checkRobot/:id?",
    component: _9f1a1650,
    name: "lang-checkRobot-id"
  }, {
    path: "/:lang/live/:id?",
    component: _033d5bc2,
    name: "lang-live-id"
  }, {
    path: "/:lang/login2.html",
    component: _37f9133a,
    name: "login2.html"
  }, {
    path: "/:lang/checkrobot",
    component: _69513b80,
    name: "checkrobot"
  }, {
    path: "/:lang/*",
    component: _9747c298,
    name: "404.html"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
